var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onCreate
    }
  }, [_vm._v("创建新活动")]), _c('div', {
    staticClass: "btn btn-create",
    on: {
      "click": _vm.onRefresh
    }
  }, [_vm.isLoading ? [_vm._v("读取中...")] : [_vm._v("刷新")]], 2)]), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab",
    class: _vm.selectTab == 1 && 'active',
    on: {
      "click": function ($event) {
        _vm.selectTab = 1;
        _vm.condition.page = 1;
        _vm.onRefresh();
      }
    }
  }, [_vm._v("启用的")]), _c('div', {
    staticClass: "tab",
    class: _vm.selectTab == 99 && 'active',
    on: {
      "click": function ($event) {
        _vm.selectTab = 99;
        _vm.condition.page = 1;
        _vm.onRefresh();
      }
    }
  }, [_vm._v("待开奖")]), _c('div', {
    staticClass: "tab",
    class: _vm.selectTab == 2 && 'active',
    on: {
      "click": function ($event) {
        _vm.selectTab = 2;
        _vm.condition.page = 1;
        _vm.onRefresh();
      }
    }
  }, [_vm._v("已开奖")]), _c('div', {
    staticClass: "tab",
    class: _vm.selectTab == 0 && 'active',
    on: {
      "click": function ($event) {
        _vm.selectTab = 0;
        _vm.condition.page = 1;
        _vm.onRefresh();
      }
    }
  }, [_vm._v("禁用的")])]), _c('div', {
    staticClass: "task-list"
  }, [_vm._m(0), _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      staticClass: "task-list-item"
    }, [_c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.id) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c('div', {
      staticClass: "s icon"
    }, [item.icon ? _c('img', {
      attrs: {
        "src": item.icon,
        "height": "30px"
      }
    }) : _vm._e()]), _c('div', {
      staticClass: "s type"
    }, [_vm._v(" " + _vm._s(item.type) + " ")]), _c('div', {
      staticClass: "s reward"
    }, [_vm._v(" " + _vm._s(item.ticket_cost) + " ")]), _c('div', {
      staticClass: "s reward"
    }, [_vm._v(" " + _vm._s(item.consolation_reward) + " ")]), _c('div', {
      staticClass: "s reward"
    }, [_vm._v(" " + _vm._s(item.instant_reward) + " ")]), _c('div', {
      staticClass: "s reward"
    }, [_vm._v(" " + _vm._s(item.per_pool) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.per_pool * (item.participants_count_0 + item.participants_count_1 + item.participants_vir_count_0 + item.participants_vir_count_1)) + " ")]), _c('div', {
      staticClass: "s create"
    }, [_vm._v(" " + _vm._s(_vm.cutStr(item.start_time)) + " ")]), _c('div', {
      staticClass: "s create"
    }, [_vm._v(" " + _vm._s(_vm.cutStr(item.end_time)) + " ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.participants_count_1 + item.participants_vir_count_1) + "【" + _vm._s(item.participants_vir_count_1) + "】 ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.participants_count_0 + item.participants_vir_count_0) + "【" + _vm._s(item.participants_vir_count_0) + "】 ")]), _c('div', {
      staticClass: "s label"
    }, [_vm._v(" " + _vm._s(item.claim_count) + " ")]), _c('div', {
      staticClass: "s status",
      class: `status_${item.status}`
    }, [_vm._v(" " + _vm._s(item.status == 0 ? '禁用' : '' + item.status == 1 ? '启用' : '已开奖') + " ")]), _c('div', {
      staticClass: "s"
    }, [_vm._v(" " + _vm._s(item.result == 0 ? 'No' : '' + item.result == 1 ? 'Yes' : '-') + " ")]), _c('div', {
      staticClass: "s create"
    }, [_vm._v(" " + _vm._s(item.result_time ? _vm.cutStr(item.result_time) : '-') + " ")]), _c('div', {
      staticClass: "s sort"
    }, [_vm._v(" " + _vm._s(item.sort) + " ")]), _c('div', {
      staticClass: "s create"
    }, [_vm._v(" " + _vm._s(_vm.cutStr(item.created_at)) + " ")]), _c('div', {
      staticClass: "s opt"
    }, [_c('div', {
      ref: "fixed",
      refInFor: true,
      staticClass: "fixed"
    }, [_c('div', {
      staticClass: "btn",
      on: {
        "click": function ($event) {
          return _vm.onModify(item);
        }
      }
    }, [_vm._v("编辑")]), item.status == 1 ? _c('div', {
      staticClass: "btn",
      on: {
        "click": function ($event) {
          return _vm.openEevents(item);
        }
      }
    }, [_vm._v("开奖")]) : _vm._e()])])]);
  })], 2), _c('div', {
    staticClass: "data-bd"
  }, [_c('my-pagination', {
    staticClass: "pagination",
    attrs: {
      "total": _vm.total,
      "page-size": _vm.condition.limit,
      "page": _vm.condition.page,
      "on-page-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1), _c('pop-events', {
    attrs: {
      "show": _vm.popEventsShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popEventsShow = $event;
      }
    }
  }), _c('pop-open-event', {
    attrs: {
      "show": _vm.popOpenEventShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popOpenEventShow = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "task-list-item"
  }, [_c('div', {
    staticClass: "s"
  }, [_vm._v(" ID ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 标题 ")]), _c('div', {
    staticClass: "s icon"
  }, [_vm._v(" ICON ")]), _c('div', {
    staticClass: "s type"
  }, [_vm._v(" 类型 ")]), _c('div', {
    staticClass: "s reward"
  }, [_vm._v(" 需要门票 ")]), _c('div', {
    staticClass: "s reward"
  }, [_vm._v(" 安慰奖励 ")]), _c('div', {
    staticClass: "s reward"
  }, [_vm._v(" 投票奖励(份) ")]), _c('div', {
    staticClass: "s reward"
  }, [_vm._v(" 每份奖池 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 总池子 ")]), _c('div', {
    staticClass: "s create"
  }, [_vm._v(" 开始时间 ")]), _c('div', {
    staticClass: "s create"
  }, [_vm._v(" 结束时间 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 选Yes人数 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 选No人数 ")]), _c('div', {
    staticClass: "s label"
  }, [_vm._v(" 领取人次 ")]), _c('div', {
    staticClass: "s status"
  }, [_vm._v(" 状态 ")]), _c('div', {
    staticClass: "s"
  }, [_vm._v(" 开奖结果 ")]), _c('div', {
    staticClass: "s create"
  }, [_vm._v(" 开奖时间 ")]), _c('div', {
    staticClass: "s sort"
  }, [_vm._v(" 排序 ")]), _c('div', {
    staticClass: "s create"
  }, [_vm._v(" 添加时间 ")]), _c('div', {
    staticClass: "s opt"
  })]);
}];
export { render, staticRenderFns };